module.exports = __webpack_public_path__ + "img/impostor-chilling.1e21a5b3.webp";